var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import UpgradeProfessional from './components/UpgradeProfessional/index.vue';
import MixinProfessional from '@/common/mixins/professional';
import { getEnv } from '@/common/utils/env';
import { _get } from '@/common/request/index';
var orgUrl = require('config/env').orgUrl;
import CompanyChangePopover from './components/CompanyChangePopover.vue';
import { getStorage, getCookie } from '@lhb/cache';
var WorkbenchNav = /** @class */ (function (_super) {
    __extends(WorkbenchNav, _super);
    function WorkbenchNav() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.enterpriseList = [];
        _this.showEnterprise = false;
        _this.showUpgradeDialog = false; // 显示升级弹窗提醒
        _this.delayCollapse = false; // 延迟收起
        _this.searchKey = '';
        _this.showMoreIcon = false;
        _this.timeout = null;
        _this.historyStores = [];
        _this.searchStores = [];
        _this.page = 1;
        _this.finished = false;
        return _this;
        // __scrollHandle() {
        //   // 防抖
        //   return debounce(() => {
        //     this.calcMenuShowStatus();
        //   }, 300);
        // }
        // toggleHandle() {
        //   this.__scrollHandle()();
        // }
        // 计算是否需要显示’展示更多‘
        // calcMenuShowStatus() {
        //   const menuListDocs = document.getElementsByClassName('el-menu-vertical-custom');
        //   const menuListDoc: any = menuListDocs[0];
        //   if (menuListDoc.offsetTop + menuListDoc.scrollHeight - menuListDoc.scrollTop > document.body.clientHeight) {
        //     this.showMoreIcon = true;
        //   } else {
        //     this.showMoreIcon = false;
        //   }
        // }
    }
    WorkbenchNav.prototype.watchSlideCollapse = function (newVal) {
        var _this = this;
        if (newVal) {
            this.delayCollapse = true;
            this.showMoreIcon = false;
        }
        else {
            setTimeout(function () {
                // this.calcMenuShowStatus();
                _this.delayCollapse = false;
            }, 200);
        }
    };
    Object.defineProperty(WorkbenchNav.prototype, "permissions", {
        /* computed */
        get: function () {
            var _a, _b;
            return ((_b = (_a = this.$store.state) === null || _a === void 0 ? void 0 : _a.common) === null || _b === void 0 ? void 0 : _b.permission) || {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkbenchNav.prototype, "user", {
        get: function () {
            var _a, _b;
            return ((_b = (_a = this.$store.state) === null || _a === void 0 ? void 0 : _a.common) === null || _b === void 0 ? void 0 : _b.user) || {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkbenchNav.prototype, "menuList", {
        get: function () {
            var _a, _b;
            return ((_b = (_a = this.$store.state) === null || _a === void 0 ? void 0 : _a.common) === null || _b === void 0 ? void 0 : _b.menuList) || [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkbenchNav.prototype, "ENV", {
        get: function () {
            var isProd = process.env.NODE_ENV === 'production';
            var env = isProd ? getEnv() : process.env.npm_config_env;
            return env;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkbenchNav.prototype, "activeMenu", {
        get: function () {
            var route = this.$route;
            var meta = route.meta, path = route.path;
            if (meta.activeMenu) {
                return meta.activeMenu;
            }
            return path;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkbenchNav.prototype, "hasShop", {
        get: function () {
            var _a, _b;
            var STORE = (_b = (_a = this.$store.state) === null || _a === void 0 ? void 0 : _a.common) === null || _b === void 0 ? void 0 : _b.storeInfo;
            return Array.isArray(STORE) && STORE.length;
        },
        enumerable: false,
        configurable: true
    });
    /* hooks */
    WorkbenchNav.prototype.mounted = function () {
        var _this = this;
        // if (!Array.isArray(this.menuList) || !this.menuList.length) {
        _get('/property/modules').then(function (data) {
            _this.$store.commit('UPDATE_MENU', data || []);
            // this.$forceUpdate();
            // return menus.concat(microRoutes); // 合并微应用路由
        });
        // }
        // 左侧菜单栏滚动事件
        // this.$nextTick(() => {
        //   // this.calcMenuShowStatus();
        //   const elMenu: any = document.getElementById('elMenu');
        //   elMenu.addEventListener('scroll', this.__scrollHandle());
        // });
    };
    /* methods */
    // 工作台路由跳转
    WorkbenchNav.prototype.menuItemClick = function () {
    };
    WorkbenchNav.prototype.jump = function (path) {
        this.$router.push({ path: path });
        // TODO 专业版检测，暂注释
        // this.checkHandle(() => {
        //   if (this.needUpgrade) {
        //     this.showUpgradeDialog = true;
        //     return false;
        //   }
        //   this.$router.push({ path });
        // });
    };
    WorkbenchNav.prototype.jumpToCompanyManage = function () {
        var token = getCookie('newPmsToken') || getStorage('newPmsToken');
        var url = orgUrl;
        if (this.ENV === 'IE') {
            url = 'https://ie-orm.lanhanba.net/';
        }
        window.open(url + "?token=" + token + "&clientKey=1000010");
    };
    WorkbenchNav.prototype.checkActive = function (item) {
        var navs = this.$route.path.split('/');
        if (item.indexOf('/') > -1) {
            var itemArr = item.split('/');
            return itemArr.every(function (e, i) { return e === navs[i + 1]; });
        }
        return navs[1].indexOf(item) > -1;
    };
    WorkbenchNav.prototype.loadMoreSearch = function () {
        if (this.finished)
            return;
        this.page++;
        this.getSearchData();
    };
    WorkbenchNav.prototype.changeNav = function () {
        this.$emit('update:slideCollapse', !this.slideCollapse);
        window.$_EventLib.dispatch('NAVCHANGE', null);
    };
    __decorate([
        Prop({
            type: Boolean,
            default: false,
        })
    ], WorkbenchNav.prototype, "slideCollapse", void 0);
    __decorate([
        Watch('slideCollapse', {
            immediate: true,
        })
    ], WorkbenchNav.prototype, "watchSlideCollapse", null);
    WorkbenchNav = __decorate([
        Component({
            components: { UpgradeProfessional: UpgradeProfessional, CompanyChangePopover: CompanyChangePopover },
            mixins: [MixinProfessional],
            directives: {
                'loadmore': {
                    bind: function (el, binding) {
                        var selectDom = el.querySelector('.history-list');
                        if (selectDom) {
                            selectDom.addEventListener('scroll', function () {
                                var condition = selectDom.scrollHeight - selectDom.scrollTop <= selectDom.clientHeight;
                                if (condition) {
                                    binding.value();
                                }
                            });
                        }
                    },
                },
            },
        })
    ], WorkbenchNav);
    return WorkbenchNav;
}(Vue));
export default WorkbenchNav;
